import React from "react";
import { makeStyles, Box } from "@material-ui/core";
import { useLocation } from "react-router-dom";
import TopBar from "./TopBar";
import Footer from "./Footer";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#fff",
    position: "relative",
    // height: "100vh",

    "@media(max-width:1280px)": {
      height: "auto !important",
    },
  },
  MainLayout: {
    // height: "100vh",
    overflowX: "hidden",
    paddingTop: "163px !important",
    zIndex: 999,
    "@media(max-width:1280px)": {
      paddingTop: "120px !important",
    },
  },

  footerSec: {
    position: "absolute",
    // bottom: "0px",
    left: "0px",
    right: "0px",
    zIndex: 999,
    "@media(max-width:615px)": {
      position: "relative",
    },
  },
}));

const MainLayout = ({ children }) => {
  const classes = useStyles();
  const location = useLocation();
  const navigate = useNavigate();

  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    const userLoginEmail = localStorage.getItem("user_email");

    if (!userLoginEmail) {
      navigate("/login", { replace: true });
    } else {
      setIsCheckingAuth(false);
    }
  }, [navigate]);

  // ⛔ Prevent UI render until auth check is done
  if (isCheckingAuth) return null;

  return (
    <div className={classes.root}>
      <TopBar />
      <div
        style={
          location.pathname !== "/" ? { display: "block" } : { display: "none" }
        }
      ></div>
      <div className={classes.MainLayout}>{children}</div>
      <Box className={classes.footerSec}>
        <Footer />
      </Box>
    </div>
  );
};

export default MainLayout;
